/**
 * Eventi WAHA chiesti nel webhook di ogni nuova sessione (whatsapp-setup.ts e
 * wahaProxyService.createWahaSession usano questa sola lista).
 *
 * Copia gemella nel core: flusia-core/src/domains/whatsapp/inbound/webhookEvents.ts, usata
 * dallo script che aggiorna le sessioni gia' esistenti. Tenere le due liste uguali.
 * Tutti questi eventi sono gestiti dal core (inbound/router.ts).
 * Nomi verificati su https://waha.devlike.pro/docs/how-to/events/ (26/09/2026).
 */
export const WAHA_WEBHOOK_EVENTS: readonly string[] = [
  'message',
  'message.any',
  'message.ack',
  'message.reaction',
  'message.edited',
  'message.revoked',
  'presence.update',
  'session.status',
  // Gruppi (gestiti dal core: inbound/handlers/group.ts)
  'group.v2.join',
  'group.v2.leave',
  'group.v2.participants',
  'group.v2.update',
  // Chiamate (riga in chat: ricevuta, risposta, rifiutata, persa)
  'call.received',
  'call.accepted',
  'call.rejected',
  // Sondaggi
  'poll.vote',
  'poll.vote.failed',
  // Etichette WhatsApp Business (sincronizzate con le etichette del CRM)
  'label.upsert',
  'label.deleted',
  'label.chat.added',
  'label.chat.deleted',
];
